<template>
  <div class="tinymce-editor">
    <editor v-model="myValue" :init="init" :disabled="disabled" @onClick="onClick"></editor>
  </div>
</template>

<script>
import tinymce from "tinymce/tinymce";
import Editor from "@tinymce/tinymce-vue";
import "tinymce/themes/silver/theme";
import "tinymce/plugins/image";
import "tinymce/plugins/media";
import "tinymce/plugins/table";
import "tinymce/plugins/lists";
import "tinymce/plugins/contextmenu";
import "tinymce/plugins/wordcount";
import "tinymce/plugins/colorpicker";
import "tinymce/plugins/textcolor";
import 'tinymce/plugins/fullscreen';
import "@/assets/utils/tinymce/skins/ui/oxide/skin.min.css"; //富文本样式
import "tinymce/themes/silver/theme.min.js"; //引入富文本的主要脚本
import lang from "@/assets/utils/tinymce/langs/zh_CN.js"; //引用中文语言
import { upload } from "@/api/file";

// tinymce.addI18n('zh_CN', lang); //注册中文语言
export default {
  components: {
    Editor
  },
  props: {
    //传入一个value，使组件支持v-model绑定
    value: {
      type: String,
      default: ""
    },
    maxSize: {
      default: 2097152,
      type: Number
    },
    accept: {
      default: "image/jpeg, image/png",
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    plugins: {
      type: [String, Array],
      default: "lists image media table  wordcount fullscreen"
    },
    params: {
      type: Object,
      default: {}
    },
    toolbar: {
      type: [String, Array],
      default:
        "undo redo |  formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | lists image table | removeformat fullscreen"
    }
  },
  data() {
    const self = this;
    return {

      //初始化配置
      init: {

        language_url: "assets/utils/tinymce/langs/zh_CN.js",
        language: "zh_CN",
        skin_url: "assets/utils/tinymce/skins/ui/oxide",
        // height: 400,
        plugins: this.plugins,
        toolbar: this.toolbar,
        branding: false,
        menubar: false,
        remove_trailing_brs: true,
        invalid_elements: 'a,em,font,b',
        images_upload_handler: (blobInfo, success, failure) => {
          if (blobInfo.blob().size > self.maxSize) {
            failure("文件体积过大");
          }

          if (self.accept.indexOf(blobInfo.blob().type) >= 0) {

            uploadPic();
          } else {
            failure("图片格式错误");
          }
          function uploadPic() {
            let formData = new FormData();
            // 服务端接收文件的参数名，文件数据，文件名
            formData.append("file", blobInfo.blob(), blobInfo.filename());
            upload(formData, self.params)
              .then(res => {
                // 这里返回的是你图片的地址
                success(res.data.url);
              })
              .catch(() => {
                failure("上传失败");
              });
          }
        }
      },
      myValue: this.value
    };
  },
  mounted() {
    tinymce.init({});
  },
  methods: {
    //添加相关的事件，可用的事件参照文档=> https://github.com/tinymce/tinymce-vue => All available events
    //需要什么事件可以自己增加
    onClick(e) {
      this.$emit("onClick", e, tinymce);
    },
    //可以添加一些自己的自定义事件，如清空内容
    clear() {
      this.myValue = "";
    }
  },
  watch: {
    value(newValue) {
      this.myValue = newValue;
    },
    myValue(newValue) {
      this.$emit("input", newValue);
    }
  }
};
</script>
<style scoped>
</style>